import classes from "../DatenschutzPage/Datenschutz.module.css"
import { BottomFooter } from "../../components/BottomFooter"

export const ImpressumPage = () => {
    return (
    <div className={classes.datenschutzPageContainer}>
        <div className={classes.datenschutzContainer}>
            <h1>Impressum</h1>
            <h2>Verantwortliche(r)</h2>
            <p>Stu App UG</p>
            <h3>Postanschrift</h3>
            <p>Görresstraße, 7a<br />
                40597 Düsseldorf</p>
            <h3>Kontakt</h3>
            <p>E-Mail: info@stu-studios.de</p>
            <p>Telefon: 017620291843</p>
            <h3>Vertreten durch</h3>
            <p className={classes.generator_user_input}>Haci Erkan Geschäftsführer</p>
            <h2>Eintragung</h2>
            <p>Registernummer: HRB 106152</p>
            <p>Gericht: Amtsgericht Düsseldorf</p>
            <h2>Umsatzsteuer-Identifikationsnummer</h2>
            <p>DE369759087</p>
            <h2>Hinweise zur Website</h2>
            <h3>Urheberrechtliche Hinweise</h3>
            <p>Die auf dieser Website veröffentlichten Inhalte, Bilder, Grafiken, Videos, Texte und sonstigen Werke unterliegen dem deutschen Urheberrecht. Jede Vervielfältigung, Bearbeitung, Verbreitung oder sonstige Verwertung außerhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung des jeweiligen Rechteinhabers.</p>

            <p>Soweit Inhalte nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet und entsprechend gekennzeichnet.</p>

            <p>Von Nutzern hochgeladene Inhalte verbleiben im Eigentum der jeweiligen Rechteinhaber. Mit dem Upload räumen die Nutzer der stu GmbH die zur Bereitstellung der Plattform erforderlichen Nutzungsrechte gemäß den AGB ein.</p>
            <h2>Information gemäß § 36 VSBG</h2>
            <p>Gemäß § 36 VSBG (Verbraucherstreitbeilegungsgesetz – Gesetz über die alternative Streitbeilegung in Verbrauchersachen) erklärt der Betreiber dieser Website:</p>
            <p>Wir sind weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
            <h2>Hinweis</h2>
            <p>Die Plattform der EU zur außergerichtlichen Streitbeilegung finden Sie online unter: <a href="https://ec.europa.eu/consumers/odr/">https://ec.europa.eu/consumers/odr/</a>.</p>
            <p><strong>Achtung:</strong> Seit dem 20. März 2025 können keine Beschwerden mehr eingereicht werden.</p>
        </div>
        <BottomFooter fromKontakt={true} />
    </div>
    )
}

export default ImpressumPage;
